import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'signup_auth_by_contract_success.title',
  },
  subTitle: {
    id: 'signup_auth_by_contract_success.sub_title',
  },
  AUTO: {
    id: 'signup_auth_by_contract_success.auto',
  },
  AUTOKey1: {
    id: 'signup_auth_by_contract_success.vehicle',
  },
  AUTOKey2: {
    id: 'signup_auth_by_contract_success.due_date',
  },
  AUTOKey3: {
    id: 'signup_auth_by_contract_success.matriculation',
  },
  EPARGN: {
    id: 'signup_auth_by_contract_success.epargn',
  },
  EPARGNKey1: {
    id: 'signup_auth_by_contract_success.epargn_key1',
  },
  EPARGNKey2: {
    id: 'signup_auth_by_contract_success.epargn_key2',
  },
  EPARGNKey3: {
    id: 'signup_auth_by_contract_success.epargn_key3',
  },
  MRH: {
    id: 'signup_auth_by_contract_success.mrh',
  },
  MRHKey1: {
    id: 'signup_auth_by_contract_success.mrh_key1',
  },
  MRHKey2: {
    id: 'signup_auth_by_contract_success.mrh_key2',
  },
  MRHKey3: {
    id: 'signup_auth_by_contract_success.mrh_key3',
  },
  ASI: {
    id: 'signup_auth_by_contract_success.asi',
  },
  ASIKey1: {
    id: 'signup_auth_by_contract_success.asi_key1',
  },
  ASIKey2: {
    id: 'signup_auth_by_contract_success.asi_key2',
  },
  ASIKey3: {
    id: 'signup_auth_by_contract_success.asi_key3',
  },
  HEALTH: {
    id: 'signup_auth_by_contract_success.health',
  },
  HEALTHKey1: {
    id: 'signup_auth_by_contract_success.health_key1',
  },
  HEALTHKey2: {
    id: 'signup_auth_by_contract_success.health_key2',
  },
  HEALTHKey3: {
    id: 'signup_auth_by_contract_success.health_key3',
  },
  AMC: {
    id: 'signup_auth_by_contract_success.amc',
  },
  AMCKey1: {
    id: 'signup_auth_by_contract_success.amc_key1',
  },
  AMCKey2: {
    id: 'signup_auth_by_contract_success.amc_key2',
  },
  AMCKey3: {
    id: 'signup_auth_by_contract_success.amc_key3',
  },
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
});
